import React from "react";
import {useNavigate} from "react-router-dom";
import {Button} from "reactstrap";
import SafeView from "../../../safeView/SafeView";
import "./back-styles.scss";

/** This component will go back one page with react router history */

const Back = () => {
  const navigate = useNavigate();

  return (
    <SafeView>
      <div className={"back-btn-container"}>
        <Button
          className="back-btn roboto-bold"
          onClick={() => navigate(-1)}
          data-cy={"back_button"}
        >
          Back
        </Button>
      </div>
    </SafeView>
  );
};

export default Back;
